var _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgJudgingNote(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 13,
    viewBox: "0 0 12 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.59586 10.5773L9.59743 10.5757L11.5 8.6215V0.499999L0.5 0.5L0.5 12.5H7.74078L9.59586 10.5773Z",
    stroke: "#3C41B2"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.08924 11.8636L10.8985 8.99929C10.9761 8.9202 10.9201 8.78677 10.8093 8.78677H8C7.93096 8.78677 7.875 8.84273 7.875 8.91177V11.7761C7.875 11.8881 8.01085 11.9436 8.08924 11.8636Z",
    stroke: "#3C41B2",
    strokeWidth: 0.75
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M6.82143 3.24292C6.82143 3.6374 6.48574 3.98584 6.03571 3.98584C5.58569 3.98584 5.25 3.6374 5.25 3.24292C5.25 2.84844 5.58569 2.5 6.03571 2.5C6.48574 2.5 6.82143 2.84844 6.82143 3.24292Z",
    stroke: "#3C41B2"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M5.81635 5.54396C5.77166 5.4084 5.72278 5.27739 5.67341 5.15268C5.79135 5.1686 5.91231 5.1768 6.03528 5.1768C6.15882 5.1768 6.28167 5.16815 6.40221 5.15136C6.35273 5.27606 6.30351 5.40721 6.25844 5.54279C6.08961 6.05068 5.96667 6.65494 6.09371 7.31839C6.10232 7.38644 6.12295 7.44704 6.1509 7.50006H5.91594C5.93447 7.46494 5.95017 7.42617 5.96227 7.38343L5.96753 7.36486L5.97135 7.34594C6.1069 6.6731 5.98645 6.05997 5.81635 5.54396Z",
    stroke: "#3C41B2"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgJudgingNote);
export default __webpack_public_path__ + "static/media/JudgingNote.770e62b1432862b45a10ddd59e55cb40.svg";
export { ForwardRef as ReactComponent };